export enum SubscriptionPeriod {
  Yearly = 'yearly',
  Monthly = 'monthly',
}
